<template>
  <div class="Login" style="margin-bottom: 50px; width: 100%; text-align:center;">
    <img src="../assets/logo.png" width="100px;" style="margin-top: 50px; margin-bottom: 50px; text-align: center" alt="">
    <h1 style=" text-align: center">Judy's Appointment System</h1>
    <h3 style=" text-align: center">We are logging you out...</h3>
    <v-container v-if="this.loader">
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>

<script>

import axios from 'axios';
// axios.defaults.withCredentials = true;
import {mapGetters, mapMutations} from "vuex";
export default {
  name: 'Login',
  components: {
  },
  data () {
    return {
      loader: false,
      snackObj: {
        color: '',
        text: ''
      },
    }
  },
  async mounted(){
    try {
      this.loader = true
      let res = await axios.post(`${this.getEndpoint}/auth/logout`)
      if(res.data.success){
        this.logout()
        await this.$router.push({path: "/login"})
      }
    } catch (error) {
      console.error(error);
      this.snack(error.msg || error, "error");
    } finally {
      this.loader = false
    }
  },
  computed: {
    ...mapGetters(['getEndpoint'])
  },
  methods: {
    ...mapMutations(['logout']),
    snack(text, color=""){
      this.snackObj.text = text;
      this.snackObj.color = color;

      this.$refs.snackbar.openDialog();
    },
  }

}
</script>
